import axios from 'axios'

export default {
  /**
   * Get list of Heard From options
   * @returns {AxiosPromise<any>}
   */
  get (params) {
    return axios.get('/heard-from', { params })
  }
}



// WEBPACK FOOTER //
// ./src/api/heardFrom.js